import { createContext } from 'react';

const ctx = createContext([]);
export default ctx;